import { TaskStepDto } from '@urbanx/agx.activities.client'
import { Range } from '@urbanx/agx.ui-components2'

export const getStepCompletionPercentage = (
  steps: TaskStepDto[]
): Range<0, 100> => {
  if (steps.length === 0) return 0
  const completed = steps.filter((t) => t.isCompleted).length
  return Math.round((completed / steps.length) * 100) as Range<0, 100>
}
